import React from 'react';
import {
  Box,
  HStack,
  Button,
  Icon,
  Badge,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiX, FiTag, FiUserPlus, FiTrash2, FiDownload, FiEdit3, FiMail, FiMessageSquare, FiZap, FiPrinter, FiBriefcase } from 'react-icons/fi';

export default function BulkContactActionsBar({ 
  count, 
  onUpdateTags, 
  onUpdateTypes, 
  onTransfer, 
  onDelete, 
  onExport,
  onSendEmail,
  onSendSMS,
  onClear,
  isCRMAdmin = false,
  isAllSelected = false,
  dialpadEnabled = false,
  onEnrollCampaign = null, // optional — renders only when provided (Workspace preview)
  onSendPostcard = null, // optional — renders only when provided
  onSetRecordScope = null, // optional + admin-only — company/personal record scope
}) {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box
      position="fixed"
      bottom={6}
      left="50%"
      transform="translateX(-50%)"
      bg={bg}
      borderWidth="2px"
      borderColor={borderColor}
      borderRadius="xl"
      shadow="2xl"
      px={6}
      py={4}
      zIndex={1000}
      minW="700px"
      data-tour="dashboard-bulk-bar"
    >
      <HStack spacing={4} justify="space-between">
        <HStack spacing={3}>
          <Badge colorScheme={isAllSelected ? "green" : "purple"} fontSize="md" px={3} py={1}>
            {isAllSelected ? `All ${count.toLocaleString()} selected` : `${count.toLocaleString()} selected`}
          </Badge>
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiMail} />}
            onClick={onSendEmail}
            colorScheme="blue"
            variant="solid"
          >
            Send Email
          </Button>

          {dialpadEnabled && (
            <Button
              size="sm"
              leftIcon={<Icon as={FiMessageSquare} />}
              onClick={onSendSMS}
              colorScheme="green"
              variant="solid"
            >
              Send SMS
            </Button>
          )}

          {onSendPostcard && (
            <Button
              size="sm"
              leftIcon={<Icon as={FiPrinter} />}
              onClick={onSendPostcard}
              variant="ghost"
              colorScheme="green"
            >
              Send Postcard
            </Button>
          )}

          <Button
            size="sm"
            leftIcon={<Icon as={FiTag} />}
            onClick={onUpdateTags}
            variant="ghost"
          >
            Update Tags
          </Button>

          {onEnrollCampaign && (
            <Button
              size="sm"
              leftIcon={<Icon as={FiZap} />}
              onClick={onEnrollCampaign}
              variant="ghost"
              colorScheme="purple"
            >
              Enroll in Campaign
            </Button>
          )}
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiEdit3} />}
            onClick={onUpdateTypes}
            variant="ghost"
          >
            Update Types
          </Button>
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiUserPlus} />}
            onClick={onTransfer}
            variant="ghost"
          >
            Transfer
          </Button>

          {isCRMAdmin && onSetRecordScope && (
            <Button
              size="sm"
              leftIcon={<Icon as={FiBriefcase} />}
              onClick={onSetRecordScope}
              variant="ghost"
              colorScheme="purple"
            >
              Scope
            </Button>
          )}
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiDownload} />}
            onClick={onExport}
            variant="ghost"
          >
            Export
          </Button>
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiTrash2} />}
            onClick={onDelete}
            variant="ghost"
            colorScheme="red"
          >
            Delete
          </Button>
        </HStack>

        <Button
          size="sm"
          leftIcon={<Icon as={FiX} />}
          onClick={onClear}
          variant="ghost"
        >
          Clear
        </Button>
      </HStack>
    </Box>
  );
}
